/**
 * Performs the Modulo Operation on two numbers.
 * @see https://web.archive.org/web/20090717035140if_/javascript.about.com/od/problemsolving/a/modulobug.htm
 * 
 * @param x The dividend number
 * @param y The divisor number
 */
export function mod(x: number, y: number): number
{
    return ((x % y) + y) % y;
}

/**
 * Returns the closest number to the passed value within the range of min to max, inclusive.
 * 
 * @param value The value to find the closest value to within [min, max]
 * @param min The minimum value of the constraint range
 * @param max The maximum value of the constraint range
 */
export function constrain(value: number, min: number, max: number): number
{
    return Math.min(max, Math.max(min, value));
}